<div class="layout-column custom-panel visit-plan-auto-dispatch-dialog">
  <div class="layout-row layout-align-start-center header padding-10">
    <bringoz-switch class="margin-right-10"
                    classSize="sm"
                    [checked]="enabled"
                    [name]="'autoDispatchEnabled'"
                    (onChange)="onEnabledToggle($event)">
    </bringoz-switch>
    <span class="br-body-2 font-weight-600 flex">
      <span translate>Auto Dispatch</span>
      <span class="visit-plan-auto-dispatch-dialog-time-text" *ngIf="selectedRange">{{ selectedRange.from }} - {{ selectedRange.to }}</span>
    </span>
    <bringoz-button type="tertiary"
                    [isDisabled]="saving"
                    (onClick)="onCancel()">
      <bringoz-icon iconName="close"></bringoz-icon>
    </bringoz-button>
  </div>

  <hr class="main-divider">

  <div class="layout-column padding-10 visit-plan-auto-dispatch-dialog-body">
    <span class="br-caption color-gray-600 margin-bottom-5" translate>Auto Dispatch Time Range</span>
    <div class="visit-plan-auto-dispatch-dialog-radio-list">
      <label *ngFor="let range of timeRanges"
             class="layout-row layout-align-start-center visit-plan-auto-dispatch-dialog-radio-item">
        <input type="radio"
               name="autoDispatchTimeRange"
               class="margin-right-10"
               [value]="range"
               [checked]="selectedRange?.from === range.from && selectedRange?.to === range.to"
               [disabled]="!enabled || saving"
               (change)="onRangeChange(range)"/>
        <span class="br-body-2">{{ range.from }} - {{ range.to }}</span>
      </label>
    </div>
  </div>

  <hr class="main-divider">

  <div class="layout-row layout-align-start-start padding-10 visit-plan-auto-dispatch-dialog-disclaimer">
    <bringoz-icon iconName="info-outline" classSize="sm" class="margin-right-5 color-gray-600"></bringoz-icon>
    <span class="br-caption color-gray-600" translate>AUTO_DISPATCH_DISCLAIMER</span>
  </div>

  <hr class="main-divider">

  <div class="layout-row layout-align-end-center padding-10 gap-5">
    <bringoz-button type="tertiary"
                    [isDisabled]="saving"
                    (onClick)="onCancel()">
      <span class="br-body-1 font-weight-400" translate>Cancel</span>
    </bringoz-button>
    <bringoz-button theme="secondary"
                    [isDisabled]="saving || !isDirty() || !selectedRange"
                    (onClick)="onSubmit()">
      <span translate>Submit</span>
    </bringoz-button>
  </div>
</div>
